export default "__VITE_ASSET__99043278__"